import { InputHTMLAttributes, ReactNode } from 'react';

type TCheckboxInputProps = InputHTMLAttributes<HTMLInputElement> & {
    label: string | ReactNode;
    checked?: boolean;
    handleChange?: (arg: boolean) => void;
    required?: boolean;
    className?: string;
    circle?: boolean;
    dataTestId?: string;
};

export const CheckboxInput = ({
    className,
    label,
    checked,
    handleChange,
    required,
    circle,
    dataTestId,
    disabled,
    ...inputProps
}: TCheckboxInputProps) => (
    <label
        className={`${className} flex max-w-max cursor-pointer items-start gap-2 md:gap-[15px] lg:items-center`}
        data-test-id={dataTestId || 'checkbox-item'}
    >
        <input
            className="hidden"
            type="checkbox"
            checked={checked}
            onChange={(e) => !disabled && handleChange?.(e.target.checked)}
            {...inputProps}
        />
        {circle ? (
            <div
                className={`mx-0.5 flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full ${
                    checked
                        ? "border-2 border-blue-2 after:h-3 after:w-3 after:rounded-full after:bg-gradient-to-r after:from-blue-2 after:to-blue-3  after:content-['']"
                        : 'border border-gray-3'
                }`}
                data-test-id={`checkbox-${checked}`}
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && !disabled && handleChange?.(!checked)}
            />
        ) : (
            <div
                className={`group relative mx-0.5 flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-lg ${
                    checked
                        ? 'bg-gradient-to-r from-blue-2 to-blue-3'
                        : 'border border-gray-3 hover:border-brand'
                } ${disabled ? 'cursor-not-allowed from-gray-3 to-gray-4' : ''}`}
                data-test-id={`checkbox-${checked}`}
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && !disabled && handleChange?.(!checked)}
            >
                {checked && (
                    <div className="absolute bottom-2 h-2 w-3 -rotate-45 border-b-2 border-l-2 border-b-white border-l-white"></div>
                )}
            </div>
        )}
        <div
            className={`${required ? "after:ml-1 after:text-state-error after:content-['*']" : ''}`}
        >
            {label}
        </div>
    </label>
);
